import { useParams } from 'react-router-dom';
import { PageId } from '../PageId';
import { usePageViewLogger } from './usePageViewLogger';
import { useNavigationLogger } from './useNavigationLogger';

type Props = {
  pageId?: PageId | null;
};

export function PageEvents({ pageId = null }: Props) {
  const creatorUri = useCreatorUri();
  const organizationUri = useOrganizationUri();

  usePageViewLogger({
    pageId,
    creatorUri,
    organizationUri,
  });

  useNavigationLogger({
    pageId,
    creatorUri,
    organizationUri,
  });

  return null;
}

function useCreatorUri() {
  const { artistId } = useParams<{ artistId?: string }>();
  if (artistId) return `spotify:artist:${artistId}`;
  return null;
}

function useOrganizationUri() {
  // todo figure out which routes define org in it
  return null;
}
